'use client';

import { FaIcon } from '@micks-yard/icons/FaIcon';
import { faCircleCheck } from '@micks-yard/icons/solid/faCircleCheck';
import { faCircleInfo } from '@micks-yard/icons/solid/faCircleInfo';
import { faOctagonXmark } from '@micks-yard/icons/solid/faOctagonXmark';
import { faSpinner } from '@micks-yard/icons/solid/faSpinner';
import { faTriangleExclamation } from '@micks-yard/icons/solid/faTriangleExclamation';
import { Toaster as Sonner, type ToasterProps } from 'sonner';

export function AppToaster({ ...props }: ToasterProps) {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      icons={{
        success: <FaIcon icon={faCircleCheck} className="size-4" />,
        info: <FaIcon icon={faCircleInfo} className="size-4" />,
        warning: <FaIcon icon={faTriangleExclamation} className="size-4" />,
        error: <FaIcon icon={faOctagonXmark} className="size-4" />,
        loading: <FaIcon icon={faSpinner} className="size-4" spin />,
      }}
      style={
        {
          '--normal-bg': 'var(--color-popover)',
          '--normal-text': 'var(--color-popover-foreground)',
          '--normal-border': 'var(--color-border)',
          '--border-radius': 'var(--radius)',
        } as React.CSSProperties
      }
      {...props}
    />
  );
}
